





















































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { Role } from '@/utils/constants';
import RequestCodeModal from '@/components/swine/request-code/RequestCodeModal.vue';
import { COOKIE, cookie } from '@/utils/cookie';
import { Endpoints } from '@/utils/endpoints';
import { ProfileStores } from '@/store/swine/profile/index';
import loginStore from '@/store/swine/login/login.store';
import { axios } from '@/utils/axios';
import { CurrentRoute } from '@/store/general/current-route/index';

@Component({
  components: { RequestCodeModal },
})
export default class GeneralNavBar extends Vue {
  isOpen = false;
  showRequestCodeButton = true;
  showRequestCodeModal = false;
  profileStore = ProfileStores.profile;
  currentEmail = '';
  currentRouteStore = CurrentRoute.detail;

  @Prop({
    type: Boolean,
    default: true,
  })
  private showUserProfile!: boolean;

  mounted() {
    this.updatePermissions();
  }

  navigateBack() {
    const routeName: string = this.currentRouteStore.returnLink;
    this.$router.push({
      name: routeName,
    });
  }

  disableBackButton() {
    if (
      this.currentRouteStore.returnLink === '' ||
      this.currentRouteStore.returnLink.length === 0
    ) {
      return true;
    } else {
      return false;
    }
  }

  updatePermissions() {
    if (this.profileStore.userProfile) {
      const userProfile = this.profileStore.userProfile;
      this.showRequestCodeButton =
        userProfile.role === Role.Regional || userProfile.role === Role.Viewer
          ? false
          : true;
      this.currentEmail = userProfile.email;
    }
  }

  async signOut() {
    try {
      await axios.delete(Endpoints.Signout);
      this.currentRouteStore.setReturnLinksState('');
      loginStore.resetState();
      this.profileStore.resetState();
      cookie.remove(COOKIE.TOKEN);

      this.$router.push({
        name: 'Login',
      });
    } catch (error) {
      console.error(error);
    }
  }
}
